import React from 'react'

const DoesNotEndWith = ({ property, onChange }) => {
  return (
    <div />
  )
}

export default DoesNotEndWith